export const gameHosting = {
  title: 'Game Server Hosting',
  subtitle: 'Professional Game Servers with Instant Setup',
  description:
    'Game server hosting optimized for Minecraft, with ECO and Performance plans, Pterodactyl panel and advanced DDoS protection.',

  categories: {
    standard: {
      title: 'Standard (ECO)',
      description:
        'ECO line with Intel Xeon CPUs, optimized for affordable and scalable Minecraft servers for any kind of community.'
    },
    performance: {
      title: 'Performance',
      description:
        'High performance line powered by AMD Ryzen™ 7 9700X CPU and DDR5 RAM, ideal for high player counts and heavy modpacks.'
    }
  },

  comingSoon: {
    title: 'Coming Soon',
    description:
      'The “Ultra Performance” line with even more powerful CPUs will be available soon.'
  },

  features: {
    title: 'Advanced Features',

    instantActivation: {
      title: 'Instant Activation',
      description: 'Get your server online within seconds after payment.'
    },

    ddos: {
      title: 'DDoS Protection',
      description: 'Advanced DDoS protection up to 4 Tbps included with every plan.'
    },

    cpu: {
      title: 'Premium Hardware',
      description:
        'Intel Xeon processors for the ECO line and AMD Ryzen™ 7 9700X with DDR5 RAM for the Performance line.'
    },

    ping: {
      title: 'Low Latency',
      description: 'Network optimized in European datacenters for minimal latency to players.'
    },

    panel: {
      title: 'Control Panel Features',
      features: [
        'Easy-to-use Pterodactyl interface',
        'Full FTP access',
        'Integrated file manager',
        'Real-time console access',
        'Scheduled tasks',
        'Unlimited automatic backups'
      ]
    }
  },

  minecraft: {
    title: 'Minecraft',
    price: 'from €1.40/month',
    specs: [
      'ECO plans with Intel Xeon CPUs for small and medium sized servers',
      'Performance line with AMD Ryzen™ 7 9700X CPU and DDR5 RAM',
      'Pterodactyl panel with quick plugin and modpack installation'
    ]
  },

  rust: {
    title: 'Rust',
    price: 'Coming soon',
    specs: [
      'Infrastructure optimized for high performance Rust servers',
      'Advanced DDoS protection',
      'Latest generation dedicated hardware'
    ]
  },

  plans: {
    standard: {
      eco1: {
        title: 'ECO-1',
        price: '€1.40',
        buyLink:
          'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-1',
        specs: [
          'CPU: Xeon 1 vCore @ 3.80 GHz',
          'RAM: 2GB',
          'Storage: 5GB NVME',
          'Databases: unlimited',
          'Player slots: unlimited',
          'DDoS protection: advanced',
          'Support: 24/7',
          'NOC: 12/6 standard, 24/7 emergencies'
        ]
      },
      eco2: {
        title: 'ECO-2',
        price: '€2.80',
        buyLink:
          'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-2',
        specs: [
          'CPU: Xeon 1 vCore @ 3.80 GHz',
          'RAM: 4GB',
          'Storage: 10GB NVME',
          'Databases: unlimited',
          'Player slots: unlimited',
          'DDoS protection: advanced',
          'Support: 24/7',
          'NOC: 12/6 standard, 24/7 emergencies'
        ]
      },
      domiVanilla: {
        title: 'DOMI-VANILLA',
        price: '€6.99',
        specs: [
          'CPU: i9-9900K 2 vCore @ 5.00 GHz (or better)',
          'RAM: 4GB',
          'Storage: 10GB NVMe',
          'Databases: unlimited',
          'Player slots: unlimited',
          'DDoS protection: advanced',
          'Support: 24/7',
          'NOC: 12/6 standard, 24/7 emergencies'
        ]
      },
      eco3: {
        title: 'ECO-3',
        price: '€2.80',
        buyLink:
          'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-3',
        specs: [
          'CPU: Xeon 2 vCore @ 3.80 GHz',
          'RAM: 5GB',
          'Storage: 15GB NVME',
          'Databases: unlimited',
          'Player slots: unlimited',
          'DDoS protection: advanced',
          'Support: 24/7',
          'NOC: 12/6 standard, 24/7 emergencies'
        ]
      },
      eco4: {
        title: 'ECO-4',
        price: '€4.20',
        buyLink:
          'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-4',
        specs: [
          'CPU: Xeon 2 vCore @ 3.80 GHz',
          'RAM: 6GB',
          'Storage: 20GB NVME',
          'Databases: unlimited',
          'Player slots: unlimited',
          'DDoS protection: advanced',
          'Support: 24/7',
          'NOC: 12/6 standard, 24/7 emergencies'
        ]
      },
      eco5: {
        title: 'ECO-5',
        price: '€5.60',
        buyLink:
          'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-5',
        specs: [
          'CPU: Xeon 3 vCore @ 3.80 GHz',
          'RAM: 8GB',
          'Storage: 25GB NVME',
          'Databases: unlimited',
          'Player slots: unlimited',
          'DDoS protection: advanced',
          'Support: 24/7',
          'NOC: 12/6 standard, 24/7 emergencies'
        ]
      },
      eco6: {
        title: 'ECO-6',
        price: '€7.00',
        buyLink:
          'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-6',
        specs: [
          'CPU: Xeon 3 vCore @ 3.80 GHz',
          'RAM: 10GB',
          'Storage: 30GB NVME',
          'Databases: unlimited',
          'Player slots: unlimited',
          'DDoS protection: advanced',
          'Support: 24/7',
          'NOC: 12/6 standard, 24/7 emergencies'
        ]
      },
      eco7: {
        title: 'ECO-7',
        price: '€8.40',
        buyLink:
          'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-7',
        specs: [
          'CPU: Xeon 4 vCore @ 3.80 GHz',
          'RAM: 12GB',
          'Storage: 35GB NVME',
          'Databases: unlimited',
          'Player slots: unlimited',
          'DDoS protection: advanced',
          'Support: 24/7',
          'NOC: 12/6 standard, 24/7 emergencies'
        ]
      },
      eco8: {
        title: 'ECO-8',
        price: '€9.80',
        buyLink:
          'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-8',
        specs: [
          'CPU: Xeon 4 vCore @ 3.80 GHz',
          'RAM: 14GB',
          'Storage: 40GB NVME',
          'Databases: unlimited',
          'Player slots: unlimited',
          'DDoS protection: advanced',
          'Support: 24/7',
          'NOC: 12/6 standard, 24/7 emergencies'
        ]
      },
      eco9: {
        title: 'ECO-9',
        price: '€11.20',
        buyLink:
          'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-9',
        specs: [
          'CPU: Xeon 5 vCore @ 3.80 GHz',
          'RAM: 16GB',
          'Storage: 45GB NVME',
          'Databases: unlimited',
          'Player slots: unlimited',
          'DDoS protection: advanced',
          'Support: 24/7',
          'NOC: 12/6 standard, 24/7 emergencies'
        ]
      },
      eco10: {
        title: 'ECO-10',
        price: '€12.60',
        buyLink:
          'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-10',
        specs: [
          'CPU: Xeon 5 vCore @ 3.80 GHz',
          'RAM: 18GB',
          'Storage: 50GB NVME',
          'Databases: unlimited',
          'Player slots: unlimited',
          'DDoS protection: advanced',
          'Support: 24/7',
          'NOC: 12/6 standard, 24/7 emergencies'
        ]
      },
      eco11: {
        title: 'ECO-11',
        price: '€14.00',
        buyLink:
          'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-11',
        specs: [
          'CPU: Xeon 6 vCore @ 3.80 GHz',
          'RAM: 20GB',
          'Storage: 55GB NVME',
          'Databases: unlimited',
          'Player slots: unlimited',
          'DDoS protection: advanced',
          'Support: 24/7',
          'NOC: 12/6 standard, 24/7 emergencies'
        ]
      },
      eco12: {
        title: 'ECO-12',
        price: '€15.40',
        buyLink:
          'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-12',
        specs: [
          'CPU: Xeon 6 vCore @ 3.80 GHz',
          'RAM: 22GB',
          'Storage: 60GB NVME',
          'Databases: unlimited',
          'Player slots: unlimited',
          'DDoS protection: advanced',
          'Support: 24/7',
          'NOC: 12/6 standard, 24/7 emergencies'
        ]
      },
      eco13: {
        title: 'ECO-13',
        price: '€16.40',
        buyLink:
          'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-13',
        specs: [
          'CPU: Xeon 7 vCore @ 3.80 GHz',
          'RAM: 24GB',
          'Storage: 65GB NVME',
          'Databases: unlimited',
          'Player slots: unlimited',
          'DDoS protection: advanced',
          'Support: 24/7',
          'NOC: 12/6 standard, 24/7 emergencies'
        ]
      },
      eco14: {
        title: 'ECO-14',
        price: '€18.20',
        buyLink:
          'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-14',
        specs: [
          'CPU: Xeon 7 vCore @ 3.80 GHz',
          'RAM: 26GB',
          'Storage: 70GB NVME',
          'Databases: unlimited',
          'Player slots: unlimited',
          'DDoS protection: advanced',
          'Support: 24/7',
          'NOC: 12/6 standard, 24/7 emergencies'
        ]
      },
      eco15: {
        title: 'ECO-15',
        price: '€19.20',
        buyLink:
          'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-15',
        specs: [
          'CPU: Xeon 8 vCore @ 3.80 GHz',
          'RAM: 28GB',
          'Storage: 75GB NVME',
          'Databases: unlimited',
          'Player slots: unlimited',
          'DDoS protection: advanced',
          'Support: 24/7',
          'NOC: 12/6 standard, 24/7 emergencies'
        ]
      },
      eco16: {
        title: 'ECO-16',
        price: '€21.00',
        buyLink:
          'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-16',
        specs: [
          'CPU: Xeon 8 vCore @ 3.80 GHz',
          'RAM: 30GB',
          'Storage: 80GB NVME',
          'Databases: unlimited',
          'Player slots: unlimited',
          'DDoS protection: advanced',
          'Support: 24/7',
          'NOC: 12/6 standard, 24/7 emergencies'
        ]
      },
      eco17: {
        title: 'ECO-17',
        price: '€22.40',
        buyLink:
          'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-17',
        specs: [
          'CPU: Xeon 8 vCore @ 3.80 GHz',
          'RAM: 32GB',
          'Storage: 85GB NVME',
          'Databases: unlimited',
          'Player slots: unlimited',
          'DDoS protection: advanced',
          'Support: 24/7',
          'NOC: 12/6 standard, 24/7 emergencies'
        ]
      }
    },

    performance: {
      nano: {
        title: 'Performance Nano',
        price: '€2.99',
        specs: [
          'CPU: AMD Ryzen 7 9700X',
          'RAM: 2GB DDR5',
          'Storage: 20GB NVMe',
          'Traffic: unlimited',
          'DDoS Protection',
          '24/7 Support',
          'Up to 10 players'
        ]
      },
      micro: {
        title: 'Performance Micro',
        price: '€4.99',
        specs: [
          'CPU: AMD Ryzen 7 9700X',
          'RAM: 3GB DDR5',
          'Storage: 30GB NVMe',
          'Traffic: unlimited',
          'DDoS Protection',
          '24/7 Support',
          'Up to 15 players'
        ]
      },
      basic: {
        title: 'Performance Basic',
        price: '€6.99',
        specs: [
          'CPU: AMD Ryzen 7 9700X',
          'RAM: 4GB DDR5',
          'Storage: 40GB NVMe',
          'Traffic: unlimited',
          'DDoS Protection',
          '24/7 Support',
          'Up to 20 players'
        ]
      },
      advanced: {
        title: 'Performance Advanced',
        price: '€9.99',
        specs: [
          'CPU: AMD Ryzen 7 9700X',
          'RAM: 6GB DDR5',
          'Storage: 50GB NVMe',
          'Traffic: unlimited',
          'DDoS Protection',
          '24/7 Support',
          'Up to 30 players'
        ]
      },
      pro: {
        title: 'Performance Pro',
        price: '€14.99',
        specs: [
          'CPU: AMD Ryzen 7 9700X',
          'RAM: 8GB DDR5',
          'Storage: 60GB NVMe',
          'Traffic: unlimited',
          'DDoS Protection',
          '24/7 Support',
          'Up to 40 players'
        ]
      },
      elite: {
        title: 'Performance Elite',
        price: '€19.99',
        specs: [
          'CPU: AMD Ryzen 7 9700X',
          'RAM: 12GB DDR5',
          'Storage: 80GB NVMe',
          'Traffic: unlimited',
          'DDoS Protection',
          '24/7 Support',
          'Up to 60 players'
        ]
      },
      ultra: {
        title: 'Performance Ultra',
        price: '€24.99',
        specs: [
          'CPU: AMD Ryzen 7 9700X',
          'RAM: 16GB DDR5',
          'Storage: 100GB NVMe',
          'Traffic: unlimited',
          'DDoS Protection',
          '24/7 Support',
          'Up to 80 players'
        ]
      },
      extreme: {
        title: 'Performance Extreme',
        price: '€34.99',
        specs: [
          'CPU: AMD Ryzen 7 9700X',
          'RAM: 24GB DDR5',
          'Storage: 150GB NVMe',
          'Traffic: unlimited',
          'DDoS Protection',
          '24/7 Support',
          'Up to 120 players'
        ]
      },
      ultimate: {
        title: 'Performance Ultimate',
        price: '€49.99',
        specs: [
          'CPU: AMD Ryzen 7 9700X',
          'RAM: 32GB DDR5',
          'Storage: 200GB NVMe',
          'Traffic: unlimited',
          'DDoS Protection',
          '24/7 Support',
          'Up to 200 players'
        ]
      }
    }
  }
};
